import { render, staticRenderFns } from "./XiaOrder.vue?vue&type=template&id=363382dc&scoped=true&"
import script from "./XiaOrder.vue?vue&type=script&lang=js&"
export * from "./XiaOrder.vue?vue&type=script&lang=js&"
import style0 from "./XiaOrder.vue?vue&type=style&index=0&id=363382dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "363382dc",
  null
  
)

export default component.exports